import React, { useState } from 'react';
import CommercialisationReadinessChecklist from './CommercialisationReadinessChecklist';
import GTMStrategyPlan from './GTMStrategyPlan';
import StartupLaunchChecklist from './StartupLaunchChecklist';

const Commercialisation = ({ userRole = 'client' }) => {
  const [activeTab, setActiveTab] = useState('readiness');

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 md:py-8 lg:px-8">
        <div className="mb-6 md:mb-8">
          <h1 className="mb-2 text-2xl font-bold text-black md:text-3xl">Commercialisation</h1>
          <p className="text-gray-600">
            Access commercialisation resources and track your readiness for market entry
          </p>
        </div>

        <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow-sm md:mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex flex-wrap gap-2 px-4 md:gap-0 md:space-x-8 md:px-6">
              <button
                onClick={() => setActiveTab('readiness')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeTab === 'readiness'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Commercialisation Readiness Checklist</span>
              </button>
              <button
                onClick={() => setActiveTab('strategy')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeTab === 'strategy'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Go to Market Strategy and Commercialisation Plan</span>
              </button>
              <button
                onClick={() => setActiveTab('launch')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeTab === 'launch'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Start-Up Launch Checklist</span>
              </button>
            </nav>
          </div>

          <div className="p-4 md:p-6">
            {activeTab === 'readiness' && (
              <CommercialisationReadinessChecklist userRole={userRole} />
            )}
            {activeTab === 'strategy' && <GTMStrategyPlan userRole={userRole} />}
            {activeTab === 'launch' && <StartupLaunchChecklist userRole={userRole} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commercialisation;
